import { render } from "./FileNotFound.vue?vue&type=template&id=5b41bef0"
import script from "./FileNotFound.vue?vue&type=script&lang=js"
export * from "./FileNotFound.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__